import React from "react";

function Footer() {
  return (
    <>
      <footer>
        <div className="container">
          <div className="d-none d-sm-block">
            <div className="row line">
              <div className="col-md-10">
                <ul className="nav justify-content-start">
                  <li className="nav-item">
                    <a className="nav-link" href="#">
                      <img src="assets/images/footer-logo.png" alt="" />
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="shop.html">
                      Shop Vyldfyre NFC Card
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#">
                      How it works
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#">
                      Contact us
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-md-2">
                <ul className="nav justify-content-end">
                  <li className="nav-item">
                    <a className="nav-link" href="#">
                      <i className="fa-brands fa-instagram"></i>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link pe-0" href="#">
                      <i className="fa-brands fa-x-twitter"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="row">
              <div className="col-md-10">
                <ul className="nav">
                  <li className="nav-item">
                    <a className="nav-link" href="#">
                      Terms
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#">
                      Privacy Policy
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#">
                      Refund & Returns
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* for mobile responsive        */}
          <div className="d-md-none">
            <div className="row line">
              <div className="col-md-12">
                <ul className="nav">
                  <li className="nav-item">
                    <a className="nav-link" href="#">
                      <img src="assets/images/footer-logo.png" alt="" />
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link linksicons" href="#">
                      <i className="fa-brands fa-instagram"></i>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link pe-0" href="#">
                      <i className="fa-brands fa-x-twitter"></i>
                    </a>
                  </li>
                </ul>
                <ul className="nav">
                  <li className="nav-item">
                    <a className="nav-link" href="shop.html">
                      Shop Vyldfyre NFC Card
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#">
                      How it works
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#">
                      Contact us
                    </a>
                  </li>
                </ul>
                <ul className="nav">
                  <li className="nav-item">
                    <a className="nav-link" href="#">
                      Terms
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#">
                      Privacy Policy
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#">
                      Refund & Returns
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* end mobile resposive   */}
        </div>
      </footer>
    </>
  );
}

export default Footer;
